<template>
  <div class="relative z-50" @keydown.escape="isOpen = false">
    <!-- Dropdown button -->
    <button
      type="button"
      class="w-full bg-base-200 border border-base-300 rounded-lg px-4 py-3 flex items-center justify-between hover:bg-base-300 text-base-content touch-manipulation"
      @click="toggleOpen"
      :aria-expanded="isOpen"
      aria-haspopup="listbox"
      :aria-label="$t('components.header.language')">
      <span class="flex items-center gap-2">
        <span :class="['fi', `fi-${currentLang.icon}`, 'w-5 h-4 rounded-sm']"></span>
        <span class="font-medium uppercase tracking-wide">{{ currentLang.label }}</span>
      </span>
      <svg class="w-4 h-4 text-base-content" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown list -->
    <transition name="fade">
      <ul
        v-show="isOpen"
        :class="[
          'absolute z-[999] w-full max-h-60 overflow-auto bg-base-100 text-base-content shadow-lg rounded-md border border-base-300',
          props.alignTop ? 'bottom-full mb-1' : 'top-full mt-1',
        ]"
        role="listbox">
        <li
          v-for="lang in langs"
          :key="lang.value"
          role="option"
          :aria-selected="lang.value === locale"
          class="flex items-center justify-start px-4 py-2 cursor-pointer gap-3 hover:bg-base-200 touch-manipulation whitespace-nowrap"
          @click="selectLang(lang.value)">
          <div class="flex items-center gap-2 w-full">
            <span :class="['fi', `fi-${lang.icon}`]" class="block w-5 h-4 rounded-sm shrink-0"></span>
            <span class="block font-medium uppercase tracking-wide text-sm leading-none">
              {{ lang.label }}
            </span>
          </div>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
const emit = defineEmits<{ (e: "update:locale", value: string): void }>();
const props = defineProps<{ locale: string; alignTop?: boolean }>();

const isOpen = ref(false);
const toggleOpen = () => {
  console.log("toggle isOpen");
  isOpen.value = !isOpen.value;
};

const langs = [
  { value: "nl", label: "Nederlands", icon: "nl" },
  { value: "en", label: "English", icon: "gb" },
];

const currentLang = computed(() => langs.find(l => l.value === props.locale) ?? langs[0]);

function selectLang(value: string) {
  emit("update:locale", value);
  isOpen.value = false;
}

watch(
  () => props.locale,
  val => {
    if (!langs.some(lang => lang.value === val)) return;
    isOpen.value = false;
  }
);
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.bg-debug {
  background-color: rgba(255, 0, 0, 0.2);
}
</style>
